// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M11 21H7A3 3 0 0 1 4 18V13H11ZM20 18A3 3 0 0 1 17 21H13V13H20ZM9 2A4 4 0 0 1 12 3.35 4 4 0 0 1 15 2H15.5A1.5 1.5 0 0 1 17 3.5V4A4 4 0 0 1 16.46 6H19A2 2 0 0 1 21 8V10C21 10.36 20.9 10.71 20.73 11H13V8A1 1 0 1 0 11 8V11H3.27A2 2 0 0 1 3 10V8A2 2 0 0 1 5 6H7.54A4 4 0 0 1 7 4V3.5A1.5 1.5 0 0 1 8.5 2ZM9 4A2 2 0 0 0 11 6 2 2 0 0 0 9 4M15 4A2 2 0 0 0 13 6 2 2 0 0 0 15 4"/>';

/** Gift (features). */
const icon: IconData = {
  id: "gift",
  name: "Gift",
  category: "features",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: {
      svg: '<path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M5 12H19M5 12H19M5 12V18A2 2 0 0 0 7 20H17A2 2 0 0 0 19 18V12M5 12A1 1 0 0 1 4 11V8A1 1 0 0 1 5 7H19A1 1 0 0 1 20 8V11A1 1 0 0 1 19 12M12 20V7M12 7V6M12 7H11A3 3 0 0 1 8 4V3.5A.5.5 0 0 1 8.5 3H9A3 3 0 0 1 12 6M12 7H13A3 3 0 0 0 16 4V3.5A.5.5 0 0 0 15.5 3H15A3 3 0 0 0 12 6"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M8.5 2L9.9 2.11 10.64 2.36 11.31 2.74 12 3.37 12.85 2.63 13.54 2.28 14.29 2.07 15.5 2 16.23 2.22 16.57 2.44 16.92 3.12 17 3.5 16.89 4.9 16.64 5.64 16.45 6 19.2 6.02 19.95 6.25 20.54 6.74 20.9 7.41 21 8 20.98 11.2 20.75 11.95 20.27 12.54 20 12.71 19.98 18.2 19.82 18.98 19.67 19.34 19.24 19.97 18.97 20.24 18.34 20.67 17.98 20.82 17 21 6.8 20.98 6.02 20.82 5.66 20.67 5.03 20.24 4.76 19.97 4.33 19.34 4.18 18.98 4 18V12.71L3.46 12.27 3.1 11.59 3 11 3.02 7.8 3.25 7.05 3.73 6.46 4.41 6.1 5 6H7.55L7.28 5.46 7.07 4.71 7 3.5 7.22 2.77 7.44 2.43 8.12 2.08Z"/></g><path fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M5 12H19M5 12H19M5 12V18A2 2 0 0 0 7 20H17A2 2 0 0 0 19 18V12M5 12A1 1 0 0 1 4 11V8A1 1 0 0 1 5 7H19A1 1 0 0 1 20 8V11A1 1 0 0 1 19 12M12 20V7M12 7V6M12 7H11A3 3 0 0 1 8 4V3.5A.5.5 0 0 1 8.5 3H9A3 3 0 0 1 12 6M12 7H13A3 3 0 0 0 16 4V3.5A.5.5 0 0 0 15.5 3H15A3 3 0 0 0 12 6"/>',
    },
  },
  animation: () => import("../animations/gift.js"),
};

export default icon;
